import script from "./ChannelsForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ChannelsForm.vue?vue&type=script&setup=true&lang=js"

import "./ChannelsForm.vue?vue&type=style&index=0&id=3b20f5fe&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b20f5fe"]])

export default __exports__